import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=a5c99408&scoped=true&"
import script from "./PasswordChange.vue?vue&type=script&lang=js&"
export * from "./PasswordChange.vue?vue&type=script&lang=js&"
import style0 from "./PasswordChange.vue?vue&type=style&index=0&id=a5c99408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c99408",
  null
  
)

export default component.exports